interface FormErrorProps {
  message: string | undefined;
  testId: string;
}

/** Reusable server error display for forms. Shows a styled error banner when message is present. */
export function FormError({ message, testId }: FormErrorProps) {
  if (!message) return null;

  return (
    <div
      className="mb-4 rounded-lg bg-destructive/10 p-4 text-sm text-destructive"
      data-testid={testId}
      role="alert"
    >
      {message}
    </div>
  );
}
